import { useTranslation } from 'react-i18next';
import { RhfTextField, type RhfTextFieldProps } from './shared/RhfTextField';

export type AccountHolderNameFieldProps = Omit<RhfTextFieldProps, 'label'> & {
  label?: string;
};

/**
 * `AccountHolderNameField` — RHF-bound text input for the bank
 * account holder name on `Bank.accountName`.
 *
 * This is the *legal* name on the bank account, which often
 * differs from the platform display name — lenders match this
 * against the IBAN holder during payout verification, so we
 * surface it as a dedicated field.
 */
export function AccountHolderNameField(props: AccountHolderNameFieldProps) {
  const { t } = useTranslation('m-organization');
  return (
    <RhfTextField
      {...props}
      label={props.label ?? t('form.account_name.title')}
      placeholder={props.placeholder ?? t('form.account_name.placeholder')}
      helper={props.helper ?? t('form.account_name.helper')}
    />
  );
}
